module.exports = __webpack_public_path__ + "docs/AcreTrader.Electronic.Records.and.Signatures.Form.pdf";